import React, { FC } from 'react';
import { usePlayerMutation } from '../../api/player-admin';

import * as CSS from './player-styles';
import { Player, UpdateStatus } from '../../../database.schema';

type UpdateButtonProps = {
  player: Player;
  playerIndex: number;
  setUpdateStatus: (updateStatus: UpdateStatus) => void;
  setShowUpdate: (value: boolean) => void;
  disabled: boolean;
};

export const UpdateButton: FC<UpdateButtonProps> = ({ player, playerIndex, disabled, setUpdateStatus, setShowUpdate }) => {
  const mutation = usePlayerMutation();
  const saveCourse = () => {
    const dataToSave = { player, playerIndex };
    if (dataToSave) {
      mutation.mutate(
        { ...dataToSave },
        {
          onSuccess: (data) => {
            setShowUpdate(false);
          },
          onError: (error) => {
            setUpdateStatus({ success: false, error: true });
          },
        },
      );
    }
  };
  return (
    <CSS.Button onClick={() => saveCourse()} disabled={disabled}>
      Save
    </CSS.Button>
  );
};
